import isEmpty from 'lodash/isEmpty';
import { Parent, PendingFeeReportSummary } from '../types';

const getFatherDetails = (record: PendingFeeReportSummary) => {
  const fatherDetails = record.studentDetails?.parents?.filter(
    (parent: Parent) => parent.family.relation === 'FATHER'
  );
  return !isEmpty(fatherDetails) ? fatherDetails[0] : null;
};

const transformPendingFeeSummaryData = (
  pendingFeeReports: PendingFeeReportSummary[]
) => {
  const result: any[] = [];
  let srNo = 0;

  pendingFeeReports.map((report) => {
    const father = getFatherDetails(report);
    srNo = srNo + 1;

    const fullName =
      report.studentDetails?.name +
      ' - ' +
      (report.studentDetails?.enrollmentNo
        ? report.studentDetails.enrollmentNo + ' - '
        : '') +
      (report.grade ? report.grade + ' - ' : '') +
      (report.division || '');

    return result.push({
      'Sr. No.': srNo,
      'Enrollment No': report.studentDetails?.enrollmentNo,
      'Student Name': report.studentDetails?.name,
      'Student Full Name': fullName,
      'Student Type': 'Existing',
      'LC Expected': '',
      Class: report.grade || '',
      Section: report.division || '',
      'Academic Year': report.session || '',
      'Father Name': father?.name || '',
      'Mobile No.': '',
      Address: '',
      Amount: report.amount,
      'Bounce Charges': report.chequeBounceFee
    });
  });

  return result;
};

export { transformPendingFeeSummaryData };
